export const StoppageCodeTypes = ['Kiln', 'Mill', 'Other'] as const
export type StoppageCodeType = (typeof StoppageCodeTypes)[number]

export interface RcfaStoppageCode {
  code: string
  text: string
  type: StoppageCodeType
}

export enum RcfaStoppageKind {
  Incident = 'Incident',
  Circumstance = 'Circumstance',
  PlannedStoppage = 'PlannedStoppage'
}

export type StoppageGroup = {
  title: string
  description: string
  duration: number
  start: string
  end?: string
  code?: RcfaStoppageCode
  stoppageCategory: string
  stoppageKind: RcfaStoppageKind
  stoppageType: string
}
